import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  TextField,
  Button,
  FormControlLabel,
  Switch,
  MenuItem,
  Select,
  Box,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import Header from "../component/Header";
import DetailedTable from "../component/DetailedTable";
import useLoader from "../Hooks/useLoader";
import SnackBar from "../component/SnackBar";
import axios from "axios";
import { getMSID, getToken } from "../common";

const Detailed = () => {
  const [searchParams] = useSearchParams();
  const [selectedDate, setSelectedDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rangeOption, setRangeOption] = useState("");
  const [isRange, setIsRange] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [showFailedOnly, setShowFailedOnly] = useState(false);
  const [loader, showLoader, hideLoader] = useLoader();
  const alertRef = useRef();
  const [initialParsedDate, setInitialParsedDate] = useState(null);

  
useEffect(() => {
  const dateParam = searchParams.get("Processed_Date");
  if (dateParam) {
    const parsedDate = dayjs(dateParam);
    setInitialParsedDate(parsedDate);
    setSelectedDate(parsedDate);
    fetchTableData(parsedDate);
  }
}, [searchParams]);


  
useEffect(() => {
  if (isRange) {
    const today = dayjs();
    const start = today.subtract(6, "day");
    setRangeOption("7");
    setSelectedDate(start);
    setEndDate(today);
    fetchTableData(start, today); // API call on toggle ON
  } else {
    if (initialParsedDate) {
      setSelectedDate(initialParsedDate);
      fetchTableData(initialParsedDate); // API call on toggle OFF
    }
  }
}, [isRange]);


  const fetchTableData = async (start, end = null) => {
    try {
            const token = getToken();
      console.log("end",end)
      const inputjson = end
        ? {
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
          }
        : {
            date: start.format("YYYY-MM-DD"),
          };

      const header = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      showLoader();
      if(isRange===false){
      const response = await axios.post(
        process.env.REACT_APP_API_URI + "get_contract_details",
        inputjson,
        header
      );
       if (response.status === 200) {
        setShowTable(true);
        setTableData(response.data);
        hideLoader();
      }
    }
    else if(isRange==true){
      const response = await axios.post(
        process.env.REACT_APP_API_URI + "get_custom_contract_details",
        inputjson,
        header
      );
       if (response.status === 200) {
        setShowTable(true);
        setTableData(response.data);
        hideLoader();
      }
    }

     
    } catch (error) {
      alertRef.current.showSnackbar();
      hideLoader();
    }
  };

  const handleRangeChange = (value) => {
    setRangeOption(value);
    const today = dayjs();
    if (value === "7") {
      setSelectedDate(today.subtract(6, "day"));
      setEndDate(today);
    } else if (value === "14") {
      setSelectedDate(today.subtract(13, "day"));
      setEndDate(today);
    } else if (value === "30") {
      setSelectedDate(today.subtract(29, "day"));
      setEndDate(today);
    } else {
      setSelectedDate(null);
      setEndDate(null);
    }
  };

  const filteredData = showFailedOnly
    ? tableData.filter((row) => row.Failure_Status === "Fail")
    : tableData;

  return (
    <div className="container">
      {loader}
      <Header />
      <div style={{ padding: "20px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {/* Top Row: Date Pickers + Button + Toggle */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              mb: 2,
            }}
          >
            {/* Left side: Date pickers and button */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
              {isRange && (
                <Select
                  value={rangeOption}
                  onChange={(e) => handleRangeChange(e.target.value)}
                  displayEmpty
                  sx={{ width: 160 }}
                >
                  <MenuItem value="">Select Range</MenuItem>
                  <MenuItem value="7">Last 7 Days</MenuItem>
                  <MenuItem value="14">Last 14 Days</MenuItem>
                  <MenuItem value="30">Last 30 Days</MenuItem>
                  <MenuItem value="custom">Custom Range</MenuItem>
                </Select>
              )}

              {isRange ? (
                rangeOption === "custom" && (
                  <>
                    <DatePicker
                      label="Start Date"
                      value={selectedDate}
                      onChange={(newDate) => setSelectedDate(newDate)}
                                            
                      renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              '& .MuiPickersSectionList-root': {
                                padding: '8px 12px',
                              },
                              '& .MuiPickersInputBase-sectionsContainer': {
                                padding: '8px 12px',
                              },
                              '& .MuiPickersOutlinedInput-sectionsContainer': {
                                padding: '8px 12px',
                              },
                            }}
                          />
                        )}

                    />
                    <DatePicker
                      label="End Date"
                      value={endDate}
                      onChange={(newDate) => setEndDate(newDate)}
                                            
                      renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              '& .MuiPickersSectionList-root': {
                                padding: '8px 12px',
                              },
                              '& .MuiPickersInputBase-sectionsContainer': {
                                padding: '8px 12px',
                              },
                              '& .MuiPickersOutlinedInput-sectionsContainer': {
                                padding: '8px 12px',
                              },
                            }}
                          />
                        )}

                    />
                  </>
                )
              ) : (
                <DatePicker
                  value={selectedDate}
                  onChange={(newDate) => setSelectedDate(newDate)}
                />
              )}

              <Button
                variant="contained"
                onClick={() => {
                  if (isRange && rangeOption) {
                    fetchTableData(selectedDate, endDate);
                  } else {
                    fetchTableData(selectedDate);
                  }
                }}
              >
                Submit
              </Button>
            </Box>

            {/* Right side: Toggle */}
            <FormControlLabel
              control={
                <Switch
                  checked={isRange}
                  onChange={() => setIsRange((prev) => !prev)}
                />
              }
              label="Manual Queue"
            />
          </Box>

          
          <section className="lower1">
            <DetailedTable data={filteredData} tableValue={showTable} />
          </section>
        </LocalizationProvider>
      </div>
      <SnackBar ref={alertRef} />
    </div>
  );
};

export default Detailed;